import type { TmsInvoiceDetail } from '@numeo/types-main-web-app'
import { formatUsd, STATUS_GROUP_LABEL } from './format'

/** One label and its value in a preview. */
const Fact = ({ label, value }: { label: string; value: string }) => (
    <div className="flex flex-col">
        <dt className="text-xs text-foreground-muted">{label}</dt>
        <dd className="text-xs text-foreground">{value}</dd>
    </div>
)

/** An invoice read in full (`tms_invoices.list` with `detail: 'full'`): its facts and the loads on it. */
export const InvoicePreview = ({ invoice }: { invoice: TmsInvoiceDetail }) => (
    <article className="flex flex-col gap-2 rounded-xl bg-default p-3" aria-label={`Invoice ${invoice.invoice_number ?? ''}`.trim()}>
        <header className="flex items-center gap-2 text-sm font-semibold text-foreground">
            Invoice {invoice.invoice_number ?? '(no number)'}
            <span className="ml-auto text-xs font-normal text-foreground-muted">{STATUS_GROUP_LABEL[invoice.status_group] ?? invoice.status_group}</span>
        </header>
        <dl className="grid grid-cols-2 gap-2 sm:grid-cols-4">
            <Fact label="Broker" value={invoice.broker ?? '—'} />
            <Fact label="Amount due" value={formatUsd(invoice.amount_due_usd)} />
            <Fact label="Invoice date" value={invoice.invoice_date ?? '—'} />
            <Fact label="Due date" value={invoice.due_date ?? '—'} />
        </dl>
        {invoice.lines.length > 0 && (
            <ul className="flex flex-col gap-1 text-xs">
                {invoice.lines.map((line) => (
                    <li key={line.load_number} className="flex justify-between border-t border-border pt-1">
                        <span>#{line.load_number}</span>
                        <span className="tabular-nums">{formatUsd(line.amount_usd)}</span>
                    </li>
                ))}
            </ul>
        )}
    </article>
)
